import {Comparator} from "../../../../types/GenericTypes";
import {TranslationsLanguage} from "../../../../translation/config/TranslationsLanguage";

export type SystemAlerts = ReadonlyArray<SystemAlert>;

export interface SystemAlert {
    readonly level: AlertLevel;
    readonly messages: SystemAlertMessages;
    readonly url: string | null;
}

export type SystemAlertMessages = {
    [key in TranslationsLanguage]: string
};

export enum AlertLevel {
    CRITICAL = "CRITICAL",
    WARNING = "WARNING",
    INFO = "INFO"
}

const AlertOrdering = [AlertLevel.CRITICAL, AlertLevel.WARNING, AlertLevel.INFO];

export function orderAlerts(): Comparator<SystemAlert> {
    return (a, b) => {
        const aIndex = AlertOrdering.indexOf(a.level);
        const bIndex = AlertOrdering.indexOf(b.level);

        return aIndex - bIndex;
    };
}
